export default __webpack_public_path__ + "static/media/vontron.f601aa27.png";